import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';

import { EventRegistrationComponent } from '../event-registration/event-registrations';
import { EventParticipantComponent } from '../event-participant/event-participant';

// EventRegistrationComponent and EventParticipantComponent are kept NgModule-declared
// because they are statically imported by eager consumers (in-meeting-allocation,
// contact-list) and adding `imports: [SharedModule]` to their decorators creates a
// circular-initialization cycle through SharedModule. Other EventsTool components
// are standalone (see OMNI-59208).

const EVENTS_TOOL_DECLARATIONS = [
  EventRegistrationComponent,
  EventParticipantComponent,
];

@NgModule({
  imports: [SharedModule],
  declarations: EVENTS_TOOL_DECLARATIONS,
  exports: EVENTS_TOOL_DECLARATIONS,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class EventsToolModule {}
